import React from "react";
import { useFormikContext, getIn } from "formik";
// component
import { convertUTCToLocalDate } from "components/UTC/UtcConverter";
import { convertLocalToUTCDate } from "components/UTC/UtcConverter";
// direct import
import { MyCheckbox } from "../../MyCheckbox";
import AddInstallmentsPayment from "./view/AddInstallmentsPayment";
import { fontConfig } from "theme/fontConfig";

const InstallmentSection = ({ name, installmentKey }) => {
  const formik = useFormikContext();
  const { values, setFieldValue, errors, touched } = useFormikContext();

  const getFieldStatus = (fieldName) => {
    const path = `${installmentKey}.${fieldName}`;
    return {
      error: getIn(errors, path),
      touched: getIn(touched, path),
    };
  };

  const lastInstallment = getFieldStatus("lastInstallmentDate");
  const numberInstallment = getFieldStatus("numberOfInstallment");

  const checked = getIn(values, name) || false;
  const details = getIn(values, installmentKey) || {};

  return (
    <>
      <MyCheckbox
        title="Allow Installments"
        name={name}
        checked={checked}
        handlechange={(e) => {
          const isChecked = e.target.checked;
          setFieldValue(name, isChecked);

          // Clear only when unchecked
          if (!isChecked) {
            setFieldValue(`${installmentKey}.numberOfInstallment`, null);
            setFieldValue(`${installmentKey}.lastInstallmentDate`, null);
          }
        }}
        titleStyles={{
          fontSize: 14,
          fontFamily: fontConfig.FormManageMyCheckboxFont.family,
          fontWeight: 500,
          color: "#3F4254",
        }}
      />

      {checked && (
        <AddInstallmentsPayment
          formikKey={installmentKey}
          installmentValue={details.numberOfInstallment}
          dateValue={
            details.lastInstallmentDate &&
            convertUTCToLocalDate(details.lastInstallmentDate)
          }
          onInstallmentChange={(val) => {
            setFieldValue(
              `${installmentKey}.numberOfInstallment`,
              val?.value ?? null
            );
          }}
          onDateChange={(date) => {
            if (!date) {
              // Reset field properly when cleared
              setFieldValue(`${installmentKey}.lastInstallmentDate`, null);
              return;
            }

            convertLocalToUTCDate(
              date,
              `${installmentKey}.lastInstallmentDate`,
              formik
            );
          }}
          manageFromOutside
          lastInstallment={lastInstallment}
          numberInstallment={numberInstallment}
        />
      )}
    </>
  );
};

export default InstallmentSection;
